import { Upload } from 'lucide-react';
import { useTheme } from '../../zustand/ThemeStore';
import React from 'react';

interface FileUploadAreaProps {
  canUpload: boolean;
  isDragging: boolean;
  setIsDragging: (b: boolean) => void;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  handleFiles: (files: FileList | null) => void;
}

const FileUploadArea: React.FC<FileUploadAreaProps> = ({ canUpload, isDragging, setIsDragging, fileInputRef, handleFiles }) => {
  const isDarkMode = useTheme((set)=> set.theme);
  return (
    <div className={`flex-1 flex items-center justify-center ${!canUpload ? 'opacity-50' : ''}`}> 
      <div
        onDragOver={(e) => {
          if (canUpload) {
            e.preventDefault();
            setIsDragging(true);
          }
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);
          if (canUpload) {
            handleFiles(e.dataTransfer.files);
          }
        }}
        className={`relative rounded-xl border-2 flex flex-col justify-center items-center border-dashed h-full p-12 text-center transition-all w-full ${
          !canUpload
            ? `${isDarkMode ? 'border-gray-700' : 'border-gray-300'} cursor-not-allowed`
            : isDragging
              ? 'border-[#1a9f6b] bg-[#1a9f6b]/10'
              : `${isDarkMode ? 'border-gray-700 hover:border-[#1a9f6b]' : 'border-gray-300 hover:border-[#1a9f6b]'} cursor-pointer`
        }`}
      >
        <Upload className={`w-16 h-16 mx-auto mb-4 ${
          canUpload 
            ? isDarkMode ? 'text-gray-500' : 'text-gray-400' 
            : isDarkMode ? 'text-gray-700' : 'text-gray-300'
        }`} />
        <p className={`text-base font-medium mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
          Drop files here or click to browse
        </p>
        <p className={`text-sm mb-6 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
          Audio: MP3, WAV, FLAC, M4A<br/>
          Text: TXT, SRT, VTT
        </p>
        <button
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
          disabled={!canUpload}
          className={`px-6 py-2.5 rounded-lg text-sm font-medium transition-all ${
            canUpload
              ? 'bg-[#1a9f6b] hover:bg-[#148856] text-white'
              : `${isDarkMode ? 'bg-[#050a0a] text-gray-600' : 'bg-gray-100 text-gray-400'} cursor-not-allowed`
          }`}
        >
          Browse Files
        </button>
      </div>
    </div>
  );
};

export default FileUploadArea;
